import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementRepository } from "../../repositories/agreement.repository";

interface EditNotesUseCaseParam {
  agreementId: number;
  notes: string;
}

export class EditNotesUseCase
  implements UseCase<EditNotesUseCaseParam, string>
{
  constructor(private repo: AgreementRepository) {}

  execute(param: EditNotesUseCaseParam): Observable<string> {
    return this.repo.editNotes(param.agreementId, param.notes);
  }
}

const editNotesUseCaseFactory = (repo: AgreementRepository) =>
  new EditNotesUseCase(repo);

export const editNotesUseCaseProvider: Provider = {
  provide: EditNotesUseCase,
  useFactory: editNotesUseCaseFactory,
  deps: [AgreementRepository],
};
